<template>
  <div id="dashboard" class="block">
    <div class="content">
      <ul>       
          <router-link
            v-for="link in links"
            :key="link.url"            
            :to="link.url"
            custom
            v-slot="{href, navigate}"
            active-class="active"

          >
            <li><a v-bind:class="{unactive_link : !link.active}" :href="href" @click="navigate">{{link.title}}</a></li>
          </router-link>
       
      </ul>
    </div>
  </div>
</template>

<script>
export default {
    data: () => ({
      links: [
        {title: 'Главная страница', url: '/main', active: true,},
        {title: 'Запись онлайн', url: '/regappointment', active: true,},
        {title: 'История визитов', url: '/history', active: true,},
        {title: 'Документы клиники', url: '/docs', active: false,},
        /*{title: 'Справка для налоговой', url: '/nalog'},
        {title: 'Консультация онлайн', url: '/consultation'},
        {title: 'Написать ген. директору', url: '/director'},
        {title: 'Полезная информация', url: '/info'},*/
      ]
    }),
  };
</script>